import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Alert, AlertDescription } from '../ui/alert';
import { Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ChatEvaluationSearch = () => {
  const navigate = useNavigate();
  const [threadId, setThreadId] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!threadId.trim()) { setError('Thread ID is required'); return; }
    navigate(`/bot-evaluation/${encodeURIComponent(threadId.trim())}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-surface via-surface-1 to-surface-2">
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-surface-1/90 backdrop-blur-md p-8 shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-ink">Chatbot Evaluation</h1>
          <p className="text-sm text-ink-dim mt-2">Enter a thread ID to review and evaluate chat conversations</p>
        </div>
        {error && <Alert variant="error" className="mb-4"><AlertDescription>{error}</AlertDescription></Alert>}
        <form onSubmit={handleSubmit}>
          <Input value={threadId} onChange={(e) => setThreadId(e.target.value)} placeholder="e.g., thread_abc123xyz" className="mb-4" autoFocus />
          <Button type="submit" className="w-full h-12 text-base gap-2"><Search className="h-5 w-5" />Load Chat</Button>
        </form>
        <p className="text-center text-xs text-ink-dim mt-4">You can evaluate individual chat turns with thumbs up/down and add comments for improvement</p>
      </div>
    </div>
  );
};

export default ChatEvaluationSearch;
